import hasItems from './hasItems';

export default function isEmpty<T>(
  value: Maybe<T[] | string>,
): value is null | undefined {
  if (value === undefined || value === null) return true;
  if (typeof value === 'string') return value === '' || value.trim() === '';

  return !hasItems(value);
}
